import React from 'react'
import InputText from '../../../../basic/InputText'
import Button from '../../../../basic/button'
import styled from 'styled-components'
import * as media from '../../../../media'
import LifeSaverImage from '../../../../static/lifesaverNormal.svg'
import HandshakeImage from '../../../../static/handshake.svg'
import BusinessImage from '../../../../static/businessNormal.svg'
import BoxImage from '../../../../static/box.svg'
import Image from '../../../../basic/image'
import {browserHistory} from 'react-router'
import requestPriceList from '../requestPriceList'
import CheckImg from '../../../../static/check-solid.svg'
import {validateEmail} from "../../../utils";
import TranslateText from 'src/text/modal';

const Container = styled.div`
  ${media.smallerThan(1074)`flex-direction: column;`}
  font-size: 12px;
  background: #173DB0;
  padding-top: 15px;
  padding-bottom: 15px;
  padding-left: 15px;
  padding-right: 15px;
  text-align: center;
`

const Checkbox = styled.div`
  display: inline-block;
  background: rgb(24, 43, 104);
  width: 15px;
  height: 15px;
  min-height: 15px;
  min-width: 15px;
  position: relative;
`

const PolicyText = styled.span`
  text-decoration: underline;
  &:hover {
    opacity: 0.5;
  }
`

const Desktop = ({style, name, email, setName, setEmail, policyAgreed, setPolicyAgreed, emailValid, setEmailValid, question, setQuestion}) => (
  <Container
    style={style}
  >
    <div
      style={{
        fontSize: 24,
        marginTop: 10,
        color: 'white',
      }}
    >
      <TranslateText id={'footer_form__title'} place="bottom" />
    </div>
    <div
      style={{
        color: 'rgb(98, 117, 174)',
        marginTop: 10,
        fontSize: 18,
      }}
    >
      <TranslateText id={'footer_form__data'} place="bottom" />
    </div>
    <TranslateText
      id="footer_form__fio"
      place="bottom"
      render={text => {
        return (
          <InputText
            placeholder={text}
            value={name}
            style={{
              width: '100%',
              height: 38,
              margin: 5,
              background: 'rgb(24, 43, 104)',
              color: 'white',
              display: 'block',
            }}
            onChange={(e) => {
              setName(e.target.value)
            }}
          />
        );
      }}
    />
    <TranslateText
      id="footer_form__email"
      place="bottom"
      render={text => {
        return (
          <InputText
            placeholder={text}
            value={email}
            style={{
              height: 38,
              width: '100%',
              margin: 5,
              background: 'rgb(24, 43, 104)',
              color: 'white',
              display: 'block',
              ...(!emailValid && {border: '4px solid red'}),
            }}
            onChange={(e) => {
              const email = e.target.value
              setEmail(e.target.value)
              setEmailValid(!email || validateEmail(email))
            }}
          />
        );
      }}
    />
    <TranslateText
      id="footer_form__text"
      place="bottom"
      render={text => {
        return (
          <InputText
            placeholder='Текст вопроса *'
            value={question}
            style={{
              height: 88,
              width: '100%',
              margin: 5,
              background: 'rgb(24, 43, 104)',
              color: 'white',
              display: 'block',
            }}
            onChange={(e) => {
              setQuestion(e.target.value)
            }}
            textArea
          />
        );
      }}
    />
    <div
      style={{
        marginTop: 10,
        display: 'flex',
        alignItems: 'center',
        textAlign: 'left',
        flexDirection: 'column',
      }}
    >
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          cursor: 'pointer',
          marginTop: 10,
          marginLeft: 5,
        }}
        onClick={() => {
          setPolicyAgreed(!policyAgreed)
        }}
      >
        <Checkbox checked={policyAgreed}>
          {
            policyAgreed && <img src={CheckImg}/>
          }
        </Checkbox>
        <div
          style={{
            display: 'inline-block',
            marginLeft: 5,
            color: 'white',
            fontSize: 14,
          }}
        >
          <TranslateText
            style={{ display: 'inline-block' }}
            id="footer__politic_info"
            place="bottom"
            render={text => {
              return (
                <PolicyText onClick={() => browserHistory.push('/policy')}>
                  {text}
                </PolicyText>
              );
            }}
          />
        </div>
      </div>
      <div
        style={{
          marginTop: 10,
          color: 'white',
          'align-self': 'flex-start',
          marginLeft: 5,
        }}
      >
        <TranslateText id="footer_form__required" place="bottom" />
      </div>
      
      <Button
        style={{
          height: 54,
          padding: '19px 39px',
          width: '100%',
          margin: 5,
          fontSize: 16,
          textAlign: 'center',
          marginTop: 20,
        }}
        disabled={!email || !emailValid || !policyAgreed || !question}
        onClick={() => {
          if (emailValid && email && policyAgreed && question) {
            requestPriceList({
              subject: 'Задать вопрос',
              email,
              question
            })
            setEmail('')
            setEmailValid(true)
            setName('')
            setQuestion('')
            window.dataLayer.push({'event': 'vopros_na'});
          }
        }}
      >
        <TranslateText id="footer_form__send_btn" />
      </Button>

    </div>
    <div
      style={{
        marginTop: 20,
        color: 'white',
        fontSize: '16px',
        textAlign: 'center',
        display: 'flex',
        flexWrap: 'wrap',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <Image
          src={BusinessImage}
          width={'38px'}
        />
        <div
          style={{
            display: 'inline-block',
            width: 250,
            marginLeft: 15,
          }}
        >
          <TranslateText style={{ display: 'inline-block' }} place="bottom" id={'footer__answer'}/>
        </div>
      </div>

      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          marginTop: 20,
        }}
      >
        <Image
          src={BoxImage}
          width={'38px'}
        />
        <div
          style={{
            display: 'inline-block',
            width: 250,
            marginLeft: 15,
          }}
        >
          <TranslateText style={{ display: 'inline-block' }} place="bottom" id={'footer__distributor'}/>
        </div>
      </div>

      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          marginTop: 20,
        }}
      >
        <Image
          src={HandshakeImage}
          width={'38px'}
        />
        <div
          style={{
            display: 'inline-block',
            width: 250,
            marginLeft: 15,
          }}
        >
          <TranslateText style={{ display: 'inline-block' }} place="bottom" id={'footer__distributor2'}/>
        </div>
      </div>

      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          marginTop: 20,
        }}
      >
        <Image
          src={LifeSaverImage}
          width={'38px'}
        />
        <div
          style={{
            display: 'inline-block',
            width: 250,
            marginLeft: 15,
          }}
        >
          <TranslateText style={{ display: 'inline-block' }} place="bottom" id={'footer__help'}/>
        </div>
      </div>
    </div>
  </Container>
)

export default Desktop


// WEBPACK FOOTER //
// ./src/finwhale/common/price-list-request/inline/Mobile.js